import {gql} from 'apollo-boost';

export const removeUserMutation = gql`
    mutation removeUser($id: Int!) {
        removeUser(id: $id)
    }
`;
